import React, { useEffect, useState, Suspense, lazy, useContext } from "react";
import Signup from "./SignupComponent/Signup";
import { auth } from "../firebase";
import { Route, BrowserRouter as Router, Redirect } from "react-router-dom";
import UserDetails from "./SignupComponent/UserDetails";
import axios from "axios";
import Paperbase from "./DashboardComponent/Paperbase";
import { ContextGlobal } from "../context";
import { LinearProgress } from "@material-ui/core";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { config } from "../config";

let theme = createMuiTheme({
  palette: {
    primary: {
      light: "#63ccff",
      main: "#009be5",
      dark: "#006db3",
    },
  },
});

const Error = lazy(() => import("./Error"));

function App() {
  const [check, setCheck] = useState("");
  const [uid, setUid] = useState("");
  const [phno, setPhno] = useState("");
  const { data, setData } = useContext(ContextGlobal);

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      if (user) {
        let user = auth.currentUser;
        if (user != null) {
          let uid = user.uid;
          setUid(uid);
          setPhno(user.phoneNumber);
          await axios
            .post(`${config.url.BACKEND}/getInfo`, {
              uid: `${uid}`,
            })
            .then((res) => {
              setData(res.data);
            })
            .catch((error) => {
              console.log(error);
              setData({ data: "server-error" });
            });

          setCheck("logged-in");
        }
      } else {
        setCheck("not-logged-in");
      }
    });
  }, [uid]);

  const logout = () => {
    auth
      .signOut()
      .then(() => {
        setUid("");
        setCheck("not-logged-in");
        console.log("success");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // console.log("main", data);
  return (
    <div className="App">
      {!uid && check === "not-logged-in" ? (
        <Signup />
      ) : (
        <Router>
          <Suspense fallback={<></>}>
            <Route path="/">
              {data.data !== "server-error" ? (
                data.data === "no-data" ? (
                  <>
                    <Redirect to="/register/user" />
                    <Route path="/register/user">
                      <UserDetails logout={logout} uid={uid} phno={phno} />
                    </Route>
                  </>
                ) : data.data ? (
                  <>
                    <Redirect
                      to={
                        data.data.type === "doctor"
                          ? "/dashboard/Scanner/reports"
                          : "/dashboard/hospitalData"
                      }
                    />
                    <Route path="/dashboard">
                      <Paperbase logout={logout} />
                    </Route>
                  </>
                ) : (
                  <ThemeProvider theme={theme}>
                    <LinearProgress />
                  </ThemeProvider>
                )
              ) : (
                <Error />
              )}
            </Route>
          </Suspense>
        </Router>
      )}
    </div>
  );
}

export default App;
